import { AuthService } from './auth.service';
import { LookupDTO } from './../models/lookup.model';
import { PublicAdministration } from './../models/publicAdministration.model';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomerDTO, CustomerFilterDTO, CustomerListDTO } from '../models/customer.model';
import { LinqFilterDTO, LinqFilterType, LinqPredicateDTO } from '../models/linqPredicate.model';
import { FilterService } from './filter.service';

@Injectable({
  providedIn: 'root'
})

export class CustomerService {

  constructor(private http: HttpClient, private filterService: FilterService, private authService: AuthService) {
  }

  getAllCustomers(type: string, filters: Array<LinqPredicateDTO> = null): Promise<Array<CustomerListDTO>> {

    if (filters == null)
      filters = new Array<LinqPredicateDTO>();

    // Filtro Company
    let filtersCompany: Array<LinqPredicateDTO> = this.filterService.getCompanyHierarchyFilter("FK_Company", false);

    // Filtro Type - Cliente o Fornitore
    let filterType: LinqPredicateDTO = new LinqPredicateDTO();
    filterType.PropertyFilters = new Array<LinqFilterDTO>();
    filterType.PropertyFilters.push(LinqFilterDTO.createFilter("Type", type, LinqFilterType.Equal));

    filters.push(filterType);

    let customerFilters: Array<LinqPredicateDTO> = filtersCompany.concat(filters);

    return this.http.post<Array<CustomerListDTO>>(environment.apiFullUrl + '/Customer/GetAll', customerFilters).toPromise();
  }

  getCustomerByID(id: number): Promise<CustomerDTO> {
    return this.http.get<CustomerDTO>(environment.apiFullUrl + '/Customer/' + id).toPromise();
  }

  saveCustomer(customer: CustomerDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Customer', customer).toPromise()
  }

  deleteCustomer(id: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/Customer/' + id).toPromise();
  }

  getFilteredCustomers(dto: CustomerFilterDTO): Promise<CustomerListDTO[]> {

    if (dto == null)
      return;

    let filters = new Array<LinqPredicateDTO>();
    // Filtro Company
    let filtersCompany: Array<LinqPredicateDTO> = this.filterService.getCompanyHierarchyFilter("FK_Company", false);

    // Filtro Type - Cliente o Fornitore
    let filterType: LinqPredicateDTO = new LinqPredicateDTO();
    filterType.PropertyFilters = new Array<LinqFilterDTO>();
    filterType.PropertyFilters.push(LinqFilterDTO.createFilter("Type", dto.Type, LinqFilterType.Equal));
    filters.push(filterType);

    // Filtro Denomination - Cliente o Fornitore
    if (dto.Denomination != null && dto.Denomination != "") {
      let filterDenomination: LinqPredicateDTO = new LinqPredicateDTO();
      filterDenomination.PropertyFilters = new Array<LinqFilterDTO>();
      filterDenomination.PropertyFilters.push(LinqFilterDTO.createFilter("Denomination", dto.Denomination, LinqFilterType.StringContains));
      filters.push(filterDenomination);
    }

    // Filtro City - Cliente o Fornitore
    if (dto.City != null && dto.City != "") {
      let filterCity: LinqPredicateDTO = new LinqPredicateDTO();
      filterCity.PropertyFilters = new Array<LinqFilterDTO>();
      filterCity.PropertyFilters.push(LinqFilterDTO.createFilter("City", dto.City, LinqFilterType.StringContains));
      filters.push(filterCity);
    }

    // Filtro CodDestFE - Cliente o Fornitore
    if (dto.CodDestFE != null && dto.CodDestFE != "") {
      let filterCodDestFE: LinqPredicateDTO = new LinqPredicateDTO();
      filterCodDestFE.PropertyFilters = new Array<LinqFilterDTO>();
      filterCodDestFE.PropertyFilters.push(LinqFilterDTO.createFilter("CodDestFE", dto.CodDestFE, LinqFilterType.StringContains));
      filters.push(filterCodDestFE);
    }

    let customerFilters: Array<LinqPredicateDTO> = filtersCompany.concat(filters);

    return this.http.post<CustomerListDTO[]>(environment.apiFullUrl + '/Customer/GetFilteredCustomers', customerFilters).toPromise();
  }

  setDisableStatus(id: number, disableStatus: boolean): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Customer/' + id + '/disablestatus/' + disableStatus).toPromise();
  }

  getPublicAdministration(label: string): Promise<PublicAdministration> {
    return this.http.get<PublicAdministration>(environment.apiFullUrl + '/Customer/GetPublicAdministration/' + label).toPromise();
  }

  getAllPublicAdministrations(): Promise<Array<LookupDTO>> {
    return this.http.get<Array<LookupDTO>>(environment.apiFullUrl + '/Customer/GetAllPublicAdministrations').toPromise();
  }

  deleteAllCustomers(fk_company: number) {
    return this.http.delete<any>(environment.apiFullUrl + '/Customer/DeleteAllCustomers/' + fk_company).toPromise();
  }

  exportAll(fk_company: number, type: string, isXls: boolean) {
    //window.open(environment.apiFullUrl + '/Customer/GetExportXls/' + fk_company + '/' + type , '_blank');
    let HTTPOptions: Object = {
      responseType: 'json'
    }
    return this.http.get<any>(environment.apiFullUrl + '/Customer/GetExport/'+ fk_company+'/' + type+"/" + isXls, HTTPOptions).toPromise();
  }

  getCustomerFromCompanyID(fk_company: number): Promise<CustomerDTO> {
    return this.http.get<CustomerDTO>(environment.apiFullUrl + '/Customer/GetCustomerFromCompanyID/' + fk_company).toPromise();
  }

  checkExistingVatNumberFiscalCode(dto: CustomerDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Customer/CheckExistingVatNumberFiscalCode', dto).toPromise();
  }

  InseefindByText(value: string, selecttype: number): Promise<any> {
    return this.http.get<CustomerDTO>(environment.apiFullUrl + '/insee/searchfromtext/' + value + '/' + selecttype).toPromise();
  }

  InseefindByTextPaged(value: string, offset: number, limit: number): Promise<any> {
    return this.http.get<CustomerDTO>(environment.apiFullUrl + '/insee/SearchFromTextPaged/' + value + '/' +  offset + '/' + limit).toPromise();
  }
}
